import type { DocumentFlowJobsResponse } from '@cavo-admin/api-interfaces';
import { JobsPageConfig, JobsPageView } from './jobs-page.config';

// Values pass through as-is (empty when missing); JobsComponent renders the
// placeholder for empties.
function toView(response: DocumentFlowJobsResponse): JobsPageView {
	return {
		summary: response.summary,
		byStage: response.byEvent,
		rows: response.jobs.map(job => ({
			statusClass: `status-${job.status}`,
			cells: {
				id: String(job.id),
				event: job.event,
				status: job.status,
				documentId: job.documentId,
				pageId: job.pageId ?? '',
				instance: job.instance,
				tries: String(job.tries),
				created: job.created,
			},
		})),
	};
}

export const DOCUMENTFLOW_JOBS_CONFIG: JobsPageConfig = {
	title: 'Document Flow Jobs',
	endpoint: '/api/jobs/documentflow',
	emptyMessage: 'No document flow jobs currently in the queue.',
	columns: [
		{ key: 'id', header: 'ID' },
		{ key: 'event', header: 'Event' },
		{ key: 'status', header: 'Status', type: 'status' },
		{ key: 'documentId', header: 'Document ID', type: 'monospace' },
		{ key: 'pageId', header: 'Page ID', type: 'monospace' },
		{ key: 'instance', header: 'Instance' },
		{ key: 'tries', header: 'Tries' },
		{ key: 'created', header: 'Created', type: 'date' },
	],
	mapResponse: response => toView(response as DocumentFlowJobsResponse),
};
